import { createAsyncThunk } from '@reduxjs/toolkit';
import type { Chantier } from '@/types';
import api from '@/api/client';
import { setChantiers, editChantier, removeChantier } from '../slices/chantierSlice';
import { setToast } from '../slices/toastSlice';

export const fetchChantiers = createAsyncThunk(
  'chantier/fetch',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const { data } = await api.get<{ data: Chantier[] }>('/chantiers/');
      dispatch(setChantiers(data.data ?? []));
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : 'Erreur chargement chantiers';
      dispatch(setToast({ message, severity: 'error' }));
      return rejectWithValue(message);
    }
  }
);

export const createChantier = createAsyncThunk<
  boolean,
  Partial<Chantier>,
  { rejectValue: string }
>('chantier/create', async (chantier, { dispatch, rejectWithValue }) => {
  try {
    await api.post('/chantiers/', chantier);
    await dispatch(fetchChantiers());
    dispatch(setToast({ message: 'Chantier est bien créé', severity: 'success' }));
    return true;
  } catch (err: unknown) {
    const message = err instanceof Error ? err.message : 'Create failed';
    return rejectWithValue(message);
  }
});

export const updateChantier = createAsyncThunk<
  boolean,
  Chantier,
  { rejectValue: string }
>('chantier/update', async (chantier, { dispatch, rejectWithValue }) => {
  try {
    await api.put(`/chantiers/${chantier.id}`, chantier);
    dispatch(editChantier(chantier));
    dispatch(setToast({ message: 'Chantier est bien modifié', severity: 'success' }));
    return true;
  } catch (err: unknown) {
    const message = err instanceof Error ? err.message : 'Update failed';
    return rejectWithValue(message);
  }
});

export const deleteChantier = createAsyncThunk<
  boolean,
  Chantier,
  { rejectValue: string }
>('chantier/delete', async (chantier, { dispatch, rejectWithValue }) => {
  try {
    await api.delete(`/chantiers/${chantier.id}`);
    dispatch(removeChantier(chantier));
    dispatch(setToast({ message: 'Chantier est bien supprimé', severity: 'success' }));
    return true;
  } catch (err: unknown) {
    const message = err instanceof Error ? err.message : 'Delete failed';
    return rejectWithValue(message);
  }
});
